import MultipleSegmentGroup from "./MultipleSegmentGroup";
import MultipleSegment from "./MultipleSegment";
import "./index.scss";
// @ts-ignore
MultipleSegment.Group = MultipleSegmentGroup;
export default MultipleSegment;
